<script>
export default {

    name: 'delete-modal',

    props:
    {
        items: Array,
        type: String,
    },

    computed:
    {
        ids()
        {
            let array = []
            if (this.items) {
                for (let i = 0; i < this.items.length; i++) {
                    array.push(this.items[i].id)
                }
                return array
            }
        }
    },

    methods: {
        cancel()
        {
            this.$refs.deleteModal.close()
        },
        openModal()
        {
            this.$refs.deleteModal.open()
        },
        archive()
        {
            for (let i = 0; i < this.ids.length; i++) {
                this.$store.dispatch(this.type, {id: this.ids[i]})
            }
            this.$emit('fetch')
            this.cancel()
        },
    }

}
</script>

<template lang="html">
    <custom-modal exitIcon="far fa-trash-alt" ref="deleteModal">
        <div slot="button">
            <custom-button iconBeforeText="fal fa-trash fa-xs mr-2" text="Discard" @buttonClick="openModal"></custom-button>
        </div>
        <div slot="header" class="">
            <p class="text-lg font-weight-semibold">
                Delete
            </p>
            <template v-if="items.length > 0">
                <div v-for="item in items">
                    <h2 class="font-weight-bold mb-0">
                        {{ item.name }}
                    </h2>
                    <p class="text-desc-color" v-if="item.client">
                        {{ item.client.name }}
                    </p>
                </div>
            </template>
            <template v-else>
                <h2 class="font-weight-bold mb-0">
                    There are no selected items
                </h2>
            </template>
        </div>
        <div>
            <p class="text-lg font-weight-bold">
                Some text ya ya ya
            </p>
            <ul class="font-awesomed-list pro trash m-0">
                <li>
                    Listable element
                </li>
            </ul>
        </div>
        <div slot="footer" class="">
            <custom-button classes="white w-120" text="CANCEL" @buttonClick="cancel"></custom-button>
            <custom-button :disabled="!items || items.length==0" classes="w-120 blue text-white" text="DELETE" @buttonClick="archive"></custom-button>
        </div>

    </custom-modal>
</template>



// WEBPACK FOOTER //
// src/components/elements/modals/delete.vue